// ===== Status bar (22px): help hint | profile | hovered bar time & OHLCV | connection/ping =====
import { useEffect, useState } from "react";
import { fmtTime, useStore } from "./store";

export default function StatusBar() {
  const { feedStatus, marketStatus } = useStore();
  const [h, setH] = useState(null);
  const [ping, setPing] = useState(42.6);
  const [kb, setKb] = useState(1820);
  useEffect(() => {
    const on = (e) => setH(e.detail);
    window.addEventListener("mt5hover", on);
    const t = setInterval(() => { setPing(+(35 + Math.random() * 20).toFixed(1)); setKb((k) => k + Math.round(Math.random() * 3)); }, 2000);
    return () => { window.removeEventListener("mt5hover", on); clearInterval(t); };
  }, []);
  const b = h && h.bar;
  const f = (v) => (b ? v.toFixed(h.dg) : "");
  return (
    <div className="mt-status" data-testid="status-bar">
      <div className="st-cell st-grow">For Help, press F1</div>
      <div className="st-cell" style={{ width: 90 }}>Default</div>
      <div className="st-cell" style={{ width: 120 }} data-testid="status-time">{b ? fmtTime(b.t) : fmtTime(Date.now())}</div>
      <div className="st-cell" style={{ width: 90 }}>O: {b && f(b.o)}</div>
      <div className="st-cell" style={{ width: 90 }}>H: {b && f(b.h)}</div>
      <div className="st-cell" style={{ width: 90 }}>L: {b && f(b.l)}</div>
      <div className="st-cell" style={{ width: 90 }}>C: {b && f(b.c)}</div>
      <div className="st-cell" style={{ width: 70 }}>V: {b && b.v}</div>
      <div className="st-cell" style={{ width: 130 }} data-testid="status-feed"><span className={`feed-dot ${feedStatus}`} />&nbsp;Binance: {feedStatus}</div>
      <div className="st-cell" style={{ width: 130 }} data-testid="status-market"><span className={`feed-dot ${marketStatus}`} />&nbsp;Markets: {marketStatus}</div>
      <div className="st-cell st-conn" style={{ width: 150 }} data-testid="status-connection">
        <span className="st-bars"><i /><i /><i /><i /></span> {ping} ms &nbsp; {kb} / 12 Kb
      </div>
    </div>
  );
}
